import { Component, ChangeDetectionStrategy, EventEmitter, Input, OnInit, Output } from '@angular/core';
//import { NavParams } from '@ionic/angular';

import { Sale } from '../../../../models/sale/sale.model';
import { List } from 'immutable';
import { SalonMonsterCurrencyPipe } from '../../../../pipes/salonmonster-currency.pipe';

@Component({
  selector: 'smr-sale-total-summary',
  templateUrl: './sale-total-summary.component.html',
  styleUrls: ['./sale-total-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SalonMonsterCurrencyPipe],
})
export class SaleTotalSummaryComponent implements OnInit {
  @Input() sale: Sale;

  constructor(private salonMonsterCurrency: SalonMonsterCurrencyPipe) { }

  ngOnInit() {}

}
